import { useState } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import { Popover } from '../../../../components/popover/popover';
import { LangEnum } from '../../../../helpers/lang';
import { useIsMobile } from '../../../../hooks/use-is-mobile';
import { useLang } from '../../../../hooks/use-lang';
import { FLAGS, LANG_OPTIONS } from './constants';
import s from './header-lang.module.css';
import { LangList } from './lang-list/lang-list';
import { MobileLangSelect } from './mobile-lang-select/mobile-header-lang';

export const HeaderLang = () => {
  const { handleChangeLang, currentLang } = useLang();
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  const selectedLang = LANG_OPTIONS.find(({ id }) => id === currentLang);

  const handleSelect = (lang: LangEnum) => {
    handleChangeLang(lang);
    setIsOpen(false);
  };

  if (isMobile) {
    return (
      <MobileLangSelect
        onOpenChange={setIsOpen}
        open={isOpen}
        selectedLang={selectedLang}
        onSelect={handleSelect}
      />
    );
  }

  return (
    <Popover
      root={{
        props: {
          open: isOpen,
          onOpenChange: setIsOpen,
        },
      }}
      arrow={{
        show: true,
      }}
      trigger={{
        props: {
          children: (
            <div className={s.label} data-testid="header-lang">
              {FLAGS[currentLang]}
              {selectedLang?.label || ''}
              <RiArrowDownSLine />
            </div>
          ),
          className: s.trigger,
        },
      }}
    >
      <LangList currentLang={currentLang} onSelect={handleSelect} />
    </Popover>
  );
};
